export const gameHosting = {
  title: 'Game Server Hosting',
  subtitle: 'Server di Gioco Professionali con Setup Istantaneo',
  description:
    'Hosting per server di gioco ottimizzato per Minecraft, con piani ECO e Performance, pannello Pterodactyl e protezione DDoS avanzata.',

  categories: {
    standard: {
      title: 'Standard (ECO)',
      description:
        'Linea ECO con CPU Intel Xeon ottimizzata per server Minecraft economici, scalabili e adatti a ogni tipo di community.'
    },
    performance: {
      title: 'Performance',
      description:
        'Linea ad alte prestazioni basata su CPU AMD Ryzen™ 7 9700X e RAM DDR5, ideale per server con molti giocatori e mod pesanti.'
    }
  },

  comingSoon: {
    title: 'Prossimamente',
    description:
      'La linea “Ultra Performance” con CPU ancora più potenti sarà disponibile a breve.'
  },

  features: {
    title: 'Funzionalità Avanzate',

    instantActivation: {
      title: 'Attivazione Istantanea',
      description: 'Ottieni il tuo server operativo in pochi secondi dopo il pagamento.'
    },

    ddos: {
      title: 'Protezione DDoS',
      description: 'Protezione avanzata fino a 4 Tbps inclusa in tutti i piani.'
    },

    cpu: {
      title: 'Hardware Premium',
      description:
        'Processori Intel Xeon per la linea ECO e AMD Ryzen™ 7 9700X con RAM DDR5 per la linea Performance.'
    },

    ping: {
      title: 'Bassa Latenza',
      description: 'Rete ottimizzata in datacenter europei per una latenza minima verso i giocatori.'
    },

    panel: {
      title: 'Funzionalità Pannello',
      features: [
        'Interfaccia Pterodactyl semplice da usare',
        'Accesso FTP completo',
        'Gestore file integrato',
        'Accesso console in tempo reale',
        'Attività pianificate',
        'Backup automatici illimitati'
      ]
    }
  },

  minecraft: {
    title: 'Minecraft',
    price: 'da €1,40/mese',
    specs: [
      'Piani ECO con CPU Intel Xeon per server piccoli e medi',
      'Linea Performance con CPU AMD Ryzen™ 7 9700X e RAM DDR5',
      'Pannello Pterodactyl con installazione rapida di plugin e modpack'
    ]
  },

  rust: {
    title: 'Rust',
    price: 'Presto disponibile',
    specs: [
      'Infrastruttura ottimizzata per server Rust ad alte prestazioni',
      'Protezione DDoS avanzata',
      'Hardware dedicato di ultima generazione'
    ]
  },

  plans: {
    standard: {
      eco1: {
        title: 'ECO-1',
        price: '€1,40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-1',
        specs: [
          'CPU: Xeon 1vCore @ 3.80 GHz',
          'Ram: 2GB',
          'Storage: 5GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco2: {
        title: 'ECO-2',
        price: '€2,80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-2',
        specs: [
          'CPU: Xeon 1vCore @ 3.80 GHz',
          'Ram: 4GB',
          'Storage: 10GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      domiVanilla: {
        title: 'DOMI-VANILLA',
        price: '€6,99',
        // buyLink da aggiungere quando lo avrai
        specs: [
          'CPU: i9-9900k 2vCore @ 5.00 GHz (o migliore)',
          'Ram: 4GB',
          'Storage: 10GB NVMe',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco3: {
        title: 'ECO-3',
        price: '€2,80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-3',
        specs: [
          'CPU: Xeon 2vCore @ 3.80 GHz',
          'Ram: 5GB',
          'Storage: 15GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco4: {
        title: 'ECO-4',
        price: '€4,20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-4',
        specs: [
          'CPU: Xeon 2vCore @ 3.80 GHz',
          'Ram: 6GB',
          'Storage: 20GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco5: {
        title: 'ECO-5',
        price: '€5,60',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-5',
        specs: [
          'CPU: Xeon 3vCore @ 3.80 GHz',
          'Ram: 8GB',
          'Storage: 25GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco6: {
        title: 'ECO-6',
        price: '€7,00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-6',
        specs: [
          'CPU: Xeon 3vCore @ 3.80 GHz',
          'Ram: 10GB',
          'Storage: 30GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco7: {
        title: 'ECO-7',
        price: '€8,40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-7',
        specs: [
          'CPU: Xeon 4vCore @ 3.80 GHz',
          'Ram: 12GB',
          'Storage: 35GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco8: {
        title: 'ECO-8',
        price: '€9,80',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-8',
        specs: [
          'CPU: Xeon 4vCore @ 3.80 GHz',
          'Ram: 14GB',
          'Storage: 40GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco9: {
        title: 'ECO-9',
        price: '€11,20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-9',
        specs: [
          'CPU: Xeon 5vCore @ 3.80 GHz',
          'Ram: 16GB',
          'Storage: 45GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco10: {
        title: 'ECO-10',
        price: '€12,60',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-10',
        specs: [
          'CPU: Xeon 5vCore @ 3.80 GHz',
          'Ram: 18GB',
          'Storage: 50GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco11: {
        title: 'ECO-11',
        price: '€14,00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-11',
        specs: [
          'CPU: Xeon 6vCore @ 3.80 GHz',
          'Ram: 20GB',
          'Storage: 55GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco12: {
        title: 'ECO-12',
        price: '€15,40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-12',
        specs: [
          'CPU: Xeon 6vCore @ 3.80 GHz',
          'Ram: 22GB',
          'Storage: 60GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco13: {
        title: 'ECO-13',
        price: '€16,40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-13',
        specs: [
          'CPU: Xeon 7vCore @ 3.80 GHz',
          'Ram: 24GB',
          'Storage: 65GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco14: {
        title: 'ECO-14',
        price: '€18,20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-14',
        specs: [
          'CPU: Xeon 7vCore @ 3.80 GHz',
          'Ram: 26GB',
          'Storage: 70GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco15: {
        title: 'ECO-15',
        price: '€19,20',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-15',
        specs: [
          'CPU: Xeon 8vCore @ 3.80 GHz',
          'Ram: 28GB',
          'Storage: 75GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco16: {
        title: 'ECO-16',
        price: '€21,00',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-16',
        specs: [
          'CPU: Xeon 8vCore @ 3.80 GHz',
          'Ram: 30GB',
          'Storage: 80GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      },
      eco17: {
        title: 'ECO-17',
        price: '€22,40',
        buyLink:
          'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-17',
        specs: [
          'CPU: Xeon 8vCore @ 3.80 GHz',
          'Ram: 32GB',
          'Storage: 85GB NVME',
          'Database: Illimitati',
          'Player slots: Illimitati',
          'Protezione DDoS: Avanzata',
          'Supporto: 24/7',
          'NOC: 12/6 ordinario, 24/7 emergenze'
        ]
      }
    },

    performance: {
      nano: {
        title: 'Performance Nano',
        price: '€2,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 2GB DDR5',
          'Storage: 20GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 10 giocatori'
        ]
      },
      micro: {
        title: 'Performance Micro',
        price: '€4,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 3GB DDR5',
          'Storage: 30GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 15 giocatori'
        ]
      },
      basic: {
        title: 'Performance Basic',
        price: '€6,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 4GB DDR5',
          'Storage: 40GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 20 giocatori'
        ]
      },
      advanced: {
        title: 'Performance Advanced',
        price: '€9,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 6GB DDR5',
          'Storage: 50GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 30 giocatori'
        ]
      },
      pro: {
        title: 'Performance Pro',
        price: '€14,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 8GB DDR5',
          'Storage: 60GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 40 giocatori'
        ]
      },
      elite: {
        title: 'Performance Elite',
        price: '€19,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 12GB DDR5',
          'Storage: 80GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 60 giocatori'
        ]
      },
      ultra: {
        title: 'Performance Ultra',
        price: '€24,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 16GB DDR5',
          'Storage: 100GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 80 giocatori'
        ]
      },
      extreme: {
        title: 'Performance Extreme',
        price: '€34,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 24GB DDR5',
          'Storage: 150GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 120 giocatori'
        ]
      },
      ultimate: {
        title: 'Performance Ultimate',
        price: '€49,99',
        specs: [
          'CPU: AMD Ryzen 7 9700X',
          'Ram: 32GB DDR5',
          'Storage: 200GB NVMe',
          'Traffico illimitato',
          'Protezione DDoS',
          'Supporto 24/7',
          'Fino a 200 giocatori'
        ]
      }
    }
  }
};
